import * as React from 'react';

import {Modal} from 'shells/modal/modal';

import type {MeetingFragment as Meeting, MeetingUpdateInput} from 'nutshell-graphql-types';

import {AddressModalContent} from './address-modal-content';
import {InboundCallModalContent} from './inbound-call-modal-content';
import {OutboundCallModalContent} from './outbound-call-modal-content';

const MODAL_CONTENT_MAP = {
    ADDRESS: AddressModalContent,
    OUTBOUND_CALL: OutboundCallModalContent,
    INBOUND_CALL: InboundCallModalContent,
} as const;

type Props = {
    modalType: 'ADDRESS' | 'OUTBOUND_CALL' | 'INBOUND_CALL';
    meeting: Meeting;
    onSave: (arg1: MeetingUpdateInput) => void;
    onFailToConnect: () => void;
    closeModal: () => void;
};

export function SmallModalWrapper(props: Props) {
    const ModalContent = MODAL_CONTENT_MAP[props.modalType];

    return (
        <Modal
            isOpen={true}
            onClose={props.onFailToConnect}
            closeButton={false}
            maxHeight={250}
            maxWidth={400}
        >
            <ModalContent
                id={props.meeting.id}
                location={props.meeting.location}
                locationType={props.meeting.locationType}
                onFailToConnect={props.onFailToConnect}
                onSave={props.onSave}
                closeModal={props.closeModal}
            />
        </Modal>
    );
}
